/* Daza Organic · anima también el CIERRE de los acordeones del producto.
   Abrir un <details> sí anima solo con CSS (grid-template-rows en
   daza-caja-compra.css): el navegador añade "open" y dispara la transición
   con normalidad. Cerrar no: al quitar "open", el navegador retira/oculta
   el contenido de <details> de forma interna antes de que la transición
   llegue a correr, así que el cierre se ve de golpe (y eso es lo que hacía
   saltar también la galería sincronizada en daza-media-sync.js, medio
   segundo después).

   Se intercepta el clic de cierre: en vez de dejar que el navegador quite
   "open" de una, se añade la clase .is-closing (que fuerza 0fr con "open"
   todavía puesto, ver CSS) y solo se quita "open" cuando esa transición ya
   terminó. Abrir no se toca. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function iniciar(details) {
    if (details.dataset.dazaAccordion) return;
    details.dataset.dazaAccordion = '1';

    var summary = details.querySelector(':scope > summary');
    var content = details.querySelector(':scope > .accordion__content');
    if (!summary || !content) return;

    summary.addEventListener('click', function (e) {
      if (!details.open) return; // se está abriendo: nativo, ya anima bien

      e.preventDefault();

      if (reduce.matches) {
        details.open = false;
        return;
      }

      if (details.classList.contains('is-closing')) return; // ya cerrando

      details.classList.add('is-closing');

      var timer;
      function terminar() {
        clearTimeout(timer);
        content.removeEventListener('transitionend', onEnd);
        details.classList.remove('is-closing');
        details.open = false;
      }
      function onEnd(ev) {
        if (ev.target === content && ev.propertyName === 'grid-template-rows') terminar();
      }
      content.addEventListener('transitionend', onEnd);
      timer = setTimeout(terminar, 500); // por si no dispara transitionend
    });
  }

  function arrancarTodo() {
    [].slice.call(document.querySelectorAll('.product__accordion details')).forEach(iniciar);
  }

  if (document.readyState !== 'loading') arrancarTodo();
  else document.addEventListener('DOMContentLoaded', arrancarTodo);
  document.addEventListener('shopify:section:load', arrancarTodo);
})();
